import {ActivatedRouteSnapshot, CanActivateChildFn, CanActivateFn, UrlTree} from "@angular/router";
import {AppContext} from "./app-context";

const runGuardLogic = (route: ActivatedRouteSnapshot): boolean | UrlTree => {
  AppContext.isNewRoute = false;
  AppContext.routeData = route.routeConfig?.data;
  $(window.document.body).removeClass("new-portvisit");
  return true;
};

export const normalRouteGuard: CanActivateFn = (route) => {
  return runGuardLogic(route);
};

export const normalChildRouteGuard: CanActivateChildFn = (childRoute) => {
  return runGuardLogic(childRoute);
};
